document.addEventListener('DOMContentLoaded', function(){
  // URL を取得
  const url = new URL(window.location.href);

  // URLSearchParamsオブジェクトを取得
  const params = url.searchParams;

  // 診療科コード
  const sectionCode = params.get('sectioncode');

  // 診療科（親ディレクトリ名）
  const sectionDir = params.get('section');

  // 表示
  const displaySchedule = document.getElementById('displaySchedule');

  // リクエストする URL
  //const requestURL = 'http://localhost:8288/system/yoshikawa/async.schedule.php'; // local
  const requestURL = 'http://kotobuki-ent.com/system/yoshikawa/async.schedule.php'; // Xserver

  // HTTP リクエストを作成するのに、new を使って XMLHttpRequest から新しいリクエストオブジェクトをつくる
  const request = new XMLHttpRequest();

  // 新しいリクエストを開始
  request.open('POST', requestURL);

  // サーバに対して解析方法を指定する
  request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );

  // リクエストを送信
  request.send( `sectioncode=${sectionCode}&section=${sectionDir}` );

  // XHR オブジェクトがサーバーから返されるデータを判断
  request.responseType = 'text';

  // リクエストに対するレスポンス (response プロパティから取得できます) を 変数へ代入
  request.onload = function(e){
    if( request.response === 'false' ){
      window.location.href = '/index.php';
      return;
    }
    displaySchedule.innerHTML = request.response;
  }

});
